import { COL_PREFERENCES } from "./constants";
import app from "../authentication/firebaseStart";
import config from "./application.properties";

const firestore = app.firestore()

/**  
      * FOR COLUMN PREFERENCE SESSION FORMAT
    
      *  let dashboardColumn = {
                DeviceDash: [...COL_PREFERENCES.DEVICE_DASHBOARD.DEFAULT_SELECTED]
                ApDash: [...]
                .... other Columns will be added like this 
         }
*/

// fetching column Data
export const getColumnsData = async (userId) => {
  // saving default values
  let dashboardColumn = {};
  dashboardColumn[COL_PREFERENCES.DEVICE_DASHBOARD.DB_NAME] = [...COL_PREFERENCES.DEVICE_DASHBOARD.DEFAULT_SELECTED]
  try {
    //getting latest value
    let columnData = await firestore
      .collection("tenants")
      .doc(config.TENANT_ID)
      .collection("Users")
      .doc(userId)
      .collection("Preferences")
      .get();

    const data = {};
    if (typeof columnData != typeof undefined) {
      columnData.forEach((col) => {
        data[col.id] = col.data();
      });
    }
    if (data?.DeviceDash?.columnOrder === undefined) {
      sessionStorage.setItem(
        "dashboardColumn",
        JSON.stringify(dashboardColumn)
      );
    } else {
      // adding column from DB
      dashboardColumn[COL_PREFERENCES.DEVICE_DASHBOARD.DB_NAME] = data.DeviceDash.columnOrder;
      sessionStorage.setItem(
        "dashboardColumn",
        JSON.stringify(dashboardColumn)
      );
    }
  } catch (err) {
    console.log(err);
    sessionStorage.setItem("dashboardColumn", JSON.stringify(dashboardColumn));
  }
};
